import { createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import reducers from "../redux/reducers/index";

const persistConfig = {
  key: 'root',
  storage,
  // whitelist: ['authToken', 'logedUser','tenantIntegrationViewReducer','dashboardViewStatus'], 
  blacklist: ['projectDetails','alertMessageReducer','apiErrMsg','apiModeReducer','tenantIdValue','sidebarStatus',],
};


const persistedReducer = persistReducer(persistConfig, reducers);

const store = createStore(
  persistedReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export const persistor = persistStore(store);

export default store;



